<template>
  <div>
    <h1>DannysPage Page</h1>
    <!-- ADD CONTENT IN THIS AREA - MUST BE BETWEEN DIV TAGS -->
    <section class="container-fluid bg-primary">
      <div class="row">
        <div class="col-sm-12 col-md-6 my-auto text-white p-5">
          <h2>DannysPage</h2>
          <p>
            Fusce lobortis nulla odio, ac eleifend metus laoreet sed. Cras
            gravida ullamcorper venenatis.
          </p>
          <ul>
            <li>List Item 1</li>
            <li>List Item 2</li>
            <li>List Item 3</li>
            <li>List Item 4</li>
          </ul>
          <p>
            Fusce lobortis nulla odio, ac eleifend metus laoreet sed. Cras
            gravida ullamcorper venenatis.
          </p>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 bg-primary p-0">
          <div class="">
            <img
              src="https://source.unsplash.com/random/1200x1200"
              title=""
              alt=""
              class="img-fluid w-100"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "DannysPage",
  route: {
    path: "/dannyspage", // this is the url path
    name: "DannysPage ",
  },
};
</script>

<style lang="scss">
// add styles here supports scss
</style>
